import AnchorAPIError from './AnchorAPIError';

const getEndpointUrl = (isCacheBust: boolean) => {
  const timestampParam = isCacheBust ? `?timestamp=${Date.now()}` : '';
  return `/api/sourceaudio/audiolibrary${timestampParam}`;
};

export const fetchAudioLibrary = async (isCacheBust: boolean) => {
  try {
    const response = await fetch(getEndpointUrl(isCacheBust), {
      method: 'GET',
      credentials: 'same-origin',
    });
    return response;
  } catch (err) {
    const { message } = err;
    throw new AnchorAPIError(err, message);
  }
};
